// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1Qxlu","fileBtn":"File_fileBtn__HVgPA","closeBtn":"File_closeBtn__32aef","fileSelected":"File_fileSelected__123JK","disabled":"File_disabled__1M8TQ"};